import { takeLatest, put, select } from 'redux-saga/effects';
import { consts as addHeightDataConst } from './add-height-data';
import { consts as addWeightDataConst } from './add-weight-data';
import { consts as historicMeasurementsConst } from './historic-measurements-req';
import { consts as weightMeasurements } from './weight-measurements-req';
import { consts as bmiMeasurements } from './bmi-measurements-req';
import { consts as vitalsActivityConst } from './vitals-activity-req';
import { ADD_DATA_MODAL as addDataModalConst } from './add-data-modal';
import { VITALS_ACTIVITY_TYPE } from '../../../components/PatientHealthboard/constants';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../context/selectors';
import {
  selectCurrentHealthboardOptionsChartPeriod,
  selectCurrentHealthboardOptionsDataType,
} from './selectors';

function* handleAddWeightHeightWorker({ type }) {
  const requestDataType = type.includes(VITALS_ACTIVITY_TYPE.WEIGHT)
    ? VITALS_ACTIVITY_TYPE.WEIGHT
    : VITALS_ACTIVITY_TYPE.HEIGHT;
  const targetUserId = yield select(targetUserIdSelector);
  const userId = yield select(loggedUserIdSelector);
  const safeId = targetUserId || userId;
  const currentDataType = yield select(selectCurrentHealthboardOptionsDataType);
  const currentChartPeriod = yield select(
    selectCurrentHealthboardOptionsChartPeriod,
  );

  yield put({
    type: historicMeasurementsConst.CLEAR,
  });

  if (requestDataType === VITALS_ACTIVITY_TYPE.WEIGHT) {
    yield put({
      type: historicMeasurementsConst.SEND,
      payload: {
        typeMeasurements: currentDataType,
        userId: safeId,
      },
    });
  }

  if (
    currentDataType === requestDataType ||
    requestDataType !== VITALS_ACTIVITY_TYPE.HEIGHT
  ) {
    yield put({
      type: vitalsActivityConst.SEND,
      payload: {
        userId: safeId,
      },
    });
  }

  if (
    requestDataType === VITALS_ACTIVITY_TYPE.WEIGHT &&
    currentDataType !== VITALS_ACTIVITY_TYPE.BMI
  ) {
    yield put({
      type: weightMeasurements.SEND,
      payload: {
        userId: safeId,
        period: currentChartPeriod,
      },
    });
  }

  if (
    currentDataType === VITALS_ACTIVITY_TYPE.BMI &&
    requestDataType !== VITALS_ACTIVITY_TYPE.HEIGHT
  ) {
    yield put({
      type: bmiMeasurements.SEND,
      payload: {
        userId: safeId,
        period: currentChartPeriod,
      },
    });
  }

  yield put({
    type: addDataModalConst.CLOSE,
  });
}

export function* handleAddWeightHeightSaga() {
  yield takeLatest(
    [addWeightDataConst.SUCCEED, addHeightDataConst.SUCCEED],
    handleAddWeightHeightWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/handle-add-weight-height-saga.js